<template>
  <v-upload :name="'file'" :action="`${SERVER_URL}/bulk-upload`" drag @change="onDocSelected">
    <p class="ant-upload-drag-icon">
      <v-icon type="inbox"></v-icon>
    </p>
    <p class="ant-upload-text">Upload Documents</p>
    <p class="ant-upload-hint">Click or Drag document to this area to upload</p>
  </v-upload>
</template>

<script>
import store from '@/store'
import { SERVER_URL } from '@/config'

export default {
  name: 'BulkUpload',
  data () {
    return {
      SERVER_URL: SERVER_URL
    }
  },
  methods: {
    onDocSelected (info) {
      if (info.file.status === 'done' || info.file.status === 'error') {
        if (info.file.response.startsWith('Error')) {
          this.$modal.info({
            title: 'Bulk upload - School / Programs',
            content: info.file.response,
            okText: 'Ok',
            onOk: async () => {
              ;
            }
          })
        } else {
          this.$modal.info({
            title: 'Bulk upload - School / Programs',
            content: 'Data processed successfully. Need a refresh to load the data.',
            okText: 'Refresh',
            onOk: async () => {
              location.reload()
            }
          })
        }        
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Admin/BulkUpload.vue